import { render } from "./NavPage.vue?vue&type=template&id=5d8d9555"
import script from "./NavPage.vue?vue&type=script&lang=ts"
export * from "./NavPage.vue?vue&type=script&lang=ts"

import "./NavPage.vue?vue&type=style&index=0&id=5d8d9555&lang=css"
script.render = render

export default script